import { render, staticRenderFns } from "./request.vue?vue&type=template&id=664fbf4a"
import script from "./request.vue?vue&type=script&lang=js"
export * from "./request.vue?vue&type=script&lang=js"
import style0 from "./request.vue?vue&type=style&index=0&id=664fbf4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputError: require('/app/components/input/error.vue').default,Postal: require('/app/components/postal.vue').default,MessageError: require('/app/components/message/error.vue').default,Loader: require('/app/components/loader.vue').default})
